
module.config(function($stateProvider) {

    $stateProvider.state('program.info', {
        url: '/info',
        abstract: true,
        templateUrl: 'programs/info/base',
    });
});
